module.exports = __webpack_public_path__ + "img/knowledge.6c60f79.svg";